var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var collector_exports = {};
__export(collector_exports, {
  Collector: () => Collector
});
module.exports = __toCommonJS(collector_exports);
var import_utils = require("./utils");
class Collector {
  data;
  constructor() {
    this.data = [];
  }
  get(labels) {
    return (0, import_utils.findExistingMetric)(labels, this.data);
  }
  set(value, labels) {
    const existing = (0, import_utils.findExistingMetric)(labels, this.data);
    if (existing) {
      existing.value = value;
    } else {
      this.data.push({
        labels,
        value
      });
    }
    return this;
  }
  collect(labels) {
    if (!labels) {
      return this.data;
    }
    return this.data.filter((item) => {
      if (!item.labels) {
        return false;
      }
      const entries = Object.entries(labels);
      for (let i = 0; i < entries.length; i += 1) {
        const [label, value] = entries[i];
        if (item.labels[label] !== value) {
          return false;
        }
      }
      return true;
    });
  }
  resetAll() {
    for (let i = 0; i < this.data.length; i += 1) {
      this.reset(this.data[i].labels);
    }
    return this;
  }
}
//# sourceMappingURL=data:application/json;base64,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
